import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { statusAlertText, statusAlertTint } from 'src/theme/statusContrast'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    /* +++++++++++++++++++++++++++++++++++++++++++++ */

    container: {
      //backgroundColor: theme.palette.background.paper,
      boxSizing: 'border-box',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(4),
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      width: '100%',
    },

    formControl: {
      boxSizing: 'border-box',
      marginBottom: theme.spacing(4),
      maxWidth: '100%',
      minWidth: 120,
      width: '100%',
      '& .MuiInputBase-root': {
        maxWidth: '100%',
        minWidth: 0,
      },
    },

    couponPromotionBanner: {
      alignItems: 'center',
      backgroundColor: 'var(--page-builder-surface, #fffaf5)',
      border: '1px solid rgba(33, 28, 23, .12)',
      borderLeft: '4px solid var(--page-builder-success, #168a4a)',
      borderRadius: 6,
      boxSizing: 'border-box',
      display: 'grid',
      gap: theme.spacing(.75, 1.15),
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      marginTop: theme.spacing(1.5),
      maxWidth: '100%',
      minWidth: 0,
      padding: theme.spacing(1.15, 1.35),
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: 'auto minmax(0, 1fr)',
      },
    },
    couponPromotionBannerGreen: {
      borderLeftColor: 'var(--page-builder-success, #168a4a)',
      color: 'var(--page-builder-text, #211c17)',
      '& $couponPromotionBadge': {
        backgroundColor: 'var(--page-builder-success, #168a4a)',
      },
      '& $couponPromotionTitle': {
        color: 'var(--page-builder-success, #168a4a)',
      },
    },
    couponPromotionBannerRed: {
      borderLeftColor: 'var(--page-builder-error, #c2410c)',
      color: 'var(--page-builder-text, #211c17)',
      '& $couponPromotionBadge': {
        backgroundColor: 'var(--page-builder-error, #c2410c)',
      },
      '& $couponPromotionTitle': {
        color: 'var(--page-builder-error, #c2410c)',
      },
    },
    couponPromotionBannerBlack: {
      borderLeftColor: 'var(--page-builder-text, #211c17)',
      color: 'var(--page-builder-text, #211c17)',
      '& $couponPromotionBadge': {
        backgroundColor: 'var(--page-builder-text, #211c17)',
      },
      '& $couponPromotionTitle': {
        color: 'var(--page-builder-text, #211c17)',
      },
    },
    couponPromotionBadge: {
      alignSelf: 'center',
      borderRadius: 4,
      color: '#fff',
      display: 'inline-flex',
      fontSize: '.74rem',
      fontWeight: 800,
      justifySelf: 'start',
      letterSpacing: 0,
      lineHeight: 1.1,
      maxWidth: '100%',
      overflow: 'hidden',
      padding: theme.spacing(.45, .7),
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    couponPromotionContent: {
      display: 'grid',
      gap: theme.spacing(.15),
      minWidth: 0,
    },
    couponPromotionTitle: {
      fontSize: '.9rem',
      fontWeight: 800,
      lineHeight: 1.2,
      overflowWrap: 'anywhere',
    },
    couponPromotionText: {
      color: 'var(--page-builder-muted, #6d6257)',
      fontSize: '.86rem',
      fontWeight: 600,
      lineHeight: 1.3,
      overflowWrap: 'anywhere',
    },
    couponPromotionExpires: {
      color: 'var(--page-builder-muted, #6d6257)',
      fontSize: '.76rem',
      fontWeight: 800,
      letterSpacing: 0,
      lineHeight: 1.25,
      marginTop: theme.spacing(.15),
      textAlign: 'left',
      whiteSpace: 'nowrap',
    },

    buttonsWrapper: {
      boxSizing: 'border-box',
      marginTop: theme.spacing(4),
      display: 'grid',
      gridTemplateColumns: '104px minmax(0, 1fr)',
      gap: theme.spacing(1.5),
      alignItems: 'stretch',
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      width: '100%',
      '& > *': {
        minWidth: 0,
      },
      '& .MuiButton-root': {
        boxSizing: 'border-box',
        maxWidth: '100%',
        minWidth: 0,
        whiteSpace: 'normal',
        width: '100%',
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '92px minmax(0, 1fr)',
      },
    },

    secondaryActionRow: {
      boxSizing: 'border-box',
      marginTop: theme.spacing(1.5),
      maxWidth: '100%',
      minWidth: 0,
      width: '100%',
    },

    /* +++++++++++++++++++++++++++++++++++++++++++++ */

    addToCartButton: {
      minHeight: 56,
      minWidth: 0,
      borderRadius: theme.shape.borderRadius,
      lineHeight: 1.25,
      overflowWrap: 'anywhere',
      width: '100%',
    },

    addToFavButton: {
      minHeight: 56,
      minWidth: 0,
      borderRadius: theme.shape.borderRadius,
      width: '100%',
      '& .MuiSvgIcon-root': {
        fontSize: '1.9rem',
      },
    },

    inquiryButton: {
      minHeight: 56,
      minWidth: 0,
      borderRadius: theme.shape.borderRadius,
      overflowWrap: 'anywhere',
      width: '100%',
    },

    deliverytimeDisplay: {
      boxSizing: 'border-box',
      marginTop: theme.spacing(2),
      maxWidth: '100%',
      minWidth: 0,
      width: '100%',
      '&& .MuiAlert-icon': {
        flexShrink: 0,
        color: 'inherit',
      },
      '& .MuiAlert-message': {
        minWidth: 0,
        overflowWrap: 'anywhere',
      },
      '&.MuiAlert-standardInfo': {
        color: `var(--page-builder-info-text, ${statusAlertText(theme.palette.info.main, 'info')})`,
        backgroundColor: `color-mix(in srgb, var(--page-builder-info, ${theme.palette.info.main}) ${statusAlertTint.info * 100}%, #ffffff)`,
      },
      '&.MuiAlert-standardSuccess': {
        color: `var(--page-builder-success-text, ${statusAlertText(theme.palette.success.main, 'success')})`,
        backgroundColor: `color-mix(in srgb, var(--page-builder-success, ${theme.palette.success.main}) ${statusAlertTint.success * 100}%, #ffffff)`,
      },
      '&.MuiAlert-standardWarning': {
        color: `var(--page-builder-warning-text, ${statusAlertText(theme.palette.warning.main, 'warning')})`,
        backgroundColor: `color-mix(in srgb, var(--page-builder-warning, ${theme.palette.warning.main}) ${statusAlertTint.warning * 100}%, #ffffff)`,
      },
      '&.MuiAlert-standardError': {
        color: `var(--page-builder-error-text, ${statusAlertText(theme.palette.error.main, 'error')})`,
        backgroundColor: `color-mix(in srgb, var(--page-builder-error, ${theme.palette.error.main}) ${statusAlertTint.error * 100}%, #ffffff)`,
      },
    },

    discountInfos: {
      marginTop: theme.spacing(2),
    },

    priceDisplay: {
      boxSizing: 'border-box',
      marginTop: theme.spacing(2),
      maxWidth: '100%',
      minWidth: 0,
      overflow: 'hidden',
      width: '100%',
    },

    stockDiscountInfo: {
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(1.25),
      borderLeft: `3px solid ${theme.palette.divider}`,
      color: `${theme.palette.text.secondary} !important`,
    },

    optionsDialogContent: {
      display: 'grid',
      gap: theme.spacing(2),
      paddingTop: `${theme.spacing(1)} !important`,
      '& $formControl': {
        marginBottom: theme.spacing(2),
      },
    },

    optionsDialogText: {
      color: theme.palette.text.secondary,
    },

    optionsDialogActions: {
      padding: theme.spacing(1, 3, 3),
      gap: theme.spacing(1),
      [theme.breakpoints.down('sm')]: {
        alignItems: 'stretch',
        flexDirection: 'column-reverse',
        '& > :not(:first-of-type)': {
          marginLeft: 0,
        },
      },
    },

    InCartInfo: {
      marginTop: theme.spacing(2),
      maxWidth: '100%',
      minWidth: 0,
      overflowWrap: 'anywhere',
      textAlign: 'center',
    },

    /* +++++++++++++++++++++++++++++++++++++++++++++ */

  })
)

export default useStyles
